import { NgModule, Optional, SkipSelf } from '@angular/core';
import { LayoutService } from '@adreno-common';
import { SharedModule } from '@app/shared/shared.module';
import { PresenceModule } from '@app/presence/presence.module';
import { SidebarHostDirective } from './directives';
import {
  CoreComponent,
  MenuSwitchComponent,
  PortalMenuComponent,
  UserProfileComponent,
} from './components';
import { UserContactModule } from '@app/user-contact/user-contact.module';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    CoreComponent,
    PortalMenuComponent,
    MenuSwitchComponent,
    UserProfileComponent,
    SidebarHostDirective,
  ],
  imports: [
    SharedModule,
    PresenceModule,
    UserContactModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
    }),
  ],
  exports: [SharedModule],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    layoutSvc: LayoutService
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
    layoutSvc.collapsable = false;
  }
}
